import { GroupRemoveOutlined, HowToRegOutlined } from '@mui/icons-material';
import { FormControlLabel, Radio, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { DELETE_GROUP_MEMBER_ACTION, OPTION_DESCRIPTION_MAX_WIDTH } from './constants';
import DeleteGroupOption from './DeleteGroupOption';

interface DeleteGroupOnlyOptionProps {
  isSelected: boolean;
  membersLosingAccessCount: number;
  membersInOtherGroupsCount: number;
}

const DeleteGroupOnlyOption: React.FC<DeleteGroupOnlyOptionProps> = ({
  isSelected,
  membersLosingAccessCount,
  membersInOtherGroupsCount
}) => {
  const { translation } = useTranslation();

  return (
    <DeleteGroupOption isSelected={isSelected}>
      <FormControlLabel
        id="delete-group-only-option"
        value={DELETE_GROUP_MEMBER_ACTION.keep}
        control={<Radio />}
        label={translation.delete_group_only_keep_users}
      />
      <Stack flexDirection="row" sx={{ px: 1.25, gap: 2 }}>
        <Stack sx={{ maxWidth: OPTION_DESCRIPTION_MAX_WIDTH }}>
          <Stack flexDirection="row" gap={1}>
            <GroupRemoveOutlined color="warning" />
            <Typography variant="body2" color="textPrimary">
              {`${membersLosingAccessCount} ${translation.users}`}
            </Typography>
          </Stack>
          <Typography variant="caption" color="textSecondary">
            {translation.users_removed_from_all_groups_summary}
          </Typography>
        </Stack>
        <Stack sx={{ maxWidth: OPTION_DESCRIPTION_MAX_WIDTH }}>
          <Stack flexDirection="row" gap={1}>
            <HowToRegOutlined color="success" />
            <Typography variant="body2" color="textPrimary">
              {`${membersInOtherGroupsCount} ${translation.users}`}
            </Typography>
          </Stack>
          <Typography variant="caption" color="textSecondary">
            {translation.users_remain_in_other_groups_summary}
          </Typography>
        </Stack>
      </Stack>
    </DeleteGroupOption>
  );
};

export default DeleteGroupOnlyOption;
